<app-dialog-header [title]="title"></app-dialog-header>
<mat-dialog-content>
  <app-s3-downloader [model]="model" [type]="type" [ratio]="ratio" [ownerCentreId]="ownerCentreId" [ownerId]="ownerId" [originalSize]="true" [noBorder]="true"></app-s3-downloader>
</mat-dialog-content>
<app-dialog-footer></app-dialog-footer>
